<template>
    <div v-if="field" class="excuse-box" :class="$safe(field,'DaySpecification.Color')">
        <!-- <span class="material-icons-outlined">{{$safe(field,'DaySpecification.Icon')}}</span>
        {{$safe(field,'DaySpecification.Name')}} -->
    </div>
    <div v-else></div>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object,
        k:String
    },
    computed:{
        isFirst(){
            return this.row.Excuses
        }
    }
}
</script>

<style>
.excuse-box{
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
</style>